import { render, staticRenderFns } from "./AddPrevention.vue?vue&type=template&id=6a8d4ff9&"
import script from "./AddPrevention.vue?vue&type=script&lang=js&"
export * from "./AddPrevention.vue?vue&type=script&lang=js&"
import style0 from "./AddPrevention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports